import { LogLevel } from '@azure/msal-browser'

import { Logger, LoggerTypes } from './utils'
import { routePaths } from './constants'

// Browser check variables
// If you support IE, our recommendation is that you sign-in using Redirect APIs
// If you as a developer are testing using Edge InPrivate mode, please add "isEdge" to the if check
const ua = window.navigator.userAgent
const msie = ua.indexOf('MSIE ')
const msie11 = ua.indexOf('Trident/')
const msedge = ua.indexOf('Edge/')
const firefox = ua.indexOf('Firefox')
const isIE = msie > 0 || msie11 > 0
const isEdge = msedge > 0
const isFirefox = firefox > 0 // Only needed if you need to support the redirect flow in Firefox incognito

// Config object to be passed to Msal on creation
export const createMsalConfig = (clientId, authority) => {
  return {
    auth: {
      clientId: clientId,
      authority: authority,
      redirectUri: routePaths.PROJECT_LIST,
      postLogoutRedirectUri: routePaths.PROJECT_LIST,
      navigateToLoginRequestUrl: false
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: isIE || isEdge || isFirefox
    },
    system: {
      loggerOptions: {
        loggerCallback: (level, message, containsPii) => {
          if (containsPii) {
            return
          }
          switch (level) {
            case LogLevel.Error:
              Logger.trace(LoggerTypes.AZURE, 'msalConfig.log(ERROR)', { message })
              return
            case LogLevel.Info:
              Logger.trace(LoggerTypes.AZURE, 'msalConfig.log(INFO)', { message })
              return
            case LogLevel.Verbose:
              Logger.trace(LoggerTypes.AZURE, 'msalConfig.log(DEBUG)', { message })
              return
            case LogLevel.Warning:
              Logger.trace(LoggerTypes.AZURE, 'msalConfig.log(WARN)', { message })
              return
            default:
              return
          }
        }
      }
    }
  }
}

export const loginRequest = {
  scopes: []
}
